export default {
    'total-bonds': 'Total bonds',
    'file-state': 'File status',
    'financial-file-fund': 'Main chashbox account',
    'undefined': 'Unassigned, please assigne one.',
    'not-posted': 'Non-posted ',
    'all-posted-bonds': 'All bonds are posted',
    'locked': 'Closed',
    'unlocked': 'Unclosed',
    "pin-account": "Pin account",
    "unpin-account": "Unpin account",
    "pinned-accounts": "Pinned accounts" 
}